function removeRoleFromListItems() {
  document.querySelectorAll('li[role="group"]').forEach(li => {
    li.removeAttribute('role');
  });
}

function addEmptyAltText() {
    document.querySelectorAll('img').forEach(img => {
        if (!img.hasAttribute('alt')) {
            img.setAttribute('alt', '')
        }
    })
}

// Run initially
removeRoleFromListItems();
addEmptyAltText();

const observer = new MutationObserver(() => {
  removeRoleFromListItems();
  addEmptyAltText();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});